import { render, staticRenderFns } from "./Birthday.vue?vue&type=template&id=849f4798"
import script from "./Birthday.vue?vue&type=script&lang=js"
export * from "./Birthday.vue?vue&type=script&lang=js"
import style0 from "./Birthday.vue?vue&type=style&index=0&id=849f4798&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports